<template>
  <div class="windowHost" @click="handelActive(idx)" :ref="'windowHost_' + idx">
    <el-dialog :visible.sync="win.winVisible" :ref="'winDialog' + idx" :modal="false" :lock-scroll="true" :show-close="false" :modal-append-to-body="true" :fullscreen="fullscreen" :close-on-click-modal="false" v-dialpad-drag>
      <header slot="title" class="win-header" @click.stop="handleheaderClick">
        <div class="win-icon">
          <el-button size="mini" type="danger" circle @click="windowClose"><i class="el-icon-close"></i></el-button>
          <el-button size="mini" type="warning" circle @click="hideWin"><i class="el-icon-minus"></i></el-button>
          <el-button size="mini" type="success" circle @click="changeFullscreen"><i class="el-icon-top-right"></i></el-button>
        </div>
        <h4 class="win-title">{{ win.menu_name }}</h4>
        <div style="width: 1.28rem;"></div>
      </header>
      <keep-alive>
        <component :is="win.component" :user="user" @updateUser="updateUser"></component>
      </keep-alive>
      <!-- <slot></slot> -->
      <div slot="footer" class="dialog-resize"></div>
    </el-dialog>
  </div>
</template>

<script>
import { calculateCustomZIndex, calculateWinZIndex } from '../lib/utils'
import { mapState } from 'vuex'
export default {
  name: 'WindowHost',
  props: {
    idx: {
      type: String,
      default: () => {
        return ''
      }
    },
    win: {
      type: Object,
      default: () => {
        return {}
      }
    },
    activeIndex: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      user: this.$store.state.userStore,
      fullscreen: false,
      localActiveIndex: this.activeIndex
    }
  },
  computed: {
    winVisible () {
      return this.$store.state.windowHostStore[this.idx].winVisible
    }
  },
  watch: {
    activeIndex (val) {
      if (val === '') return
      this.localActiveIndex = val
      this.handelActive(val)
    }
  },
  methods: {
    updateUser (updatedUser) {
      if (this.user.id === updatedUser.id) {
        this.user = updatedUser
      }
    },
    windowClose () {
      console.log('idx', this.idx)
      this.$emit('windowClose', this.idx)
    },
    changeFullscreen () {
      this.fullscreen = !this.fullscreen
    },
    hideWin () {
      // console.log(this.win)
      this.localActiveIndex = ''
      this.$emit('handelActiveIndexChange', this.localActiveIndex)
      this.$emit('changeVisible', this.idx)
    },
    handleheaderClick () {
      console.log('ddd')
    },
    handelActive (idx) {
      // console.log(this.$refs['winDialog' + this.idx])
      // const index = this.$refs.windowHosts.indexOf(event.currentTarget)
      let customZIndex = calculateCustomZIndex()
      let winZIndex = calculateWinZIndex('.windowHost')
      console.log('z-index', winZIndex)

      this.$nextTick(() => {
        let win = this.$refs['windowHost_' + idx]
        if (win) {
          if (winZIndex - parseInt(win.style.zIndex, 10) === 1) return
          win.style.zIndex = winZIndex

          let dialog = this.$refs['winDialog' + idx].$el
          if (customZIndex - parseInt(dialog.style.zIndex, 10) === 1) return
          if (dialog) {
            dialog.style.zIndex = customZIndex
          }
        }
      })
      

    },
  }
}
</script>

<style lang="stylus" scoped>
.windowHost {
  position: relative;
  z-index: 99;
}
.windowHost >>> .el-dialog__wrapper {
  pointer-events: none;
}
.windowHost >>> .el-dialog {
  width: 600px;
  height: 400px;
  overflow: auto;
  pointer-events: auto;
  user-select: none;
}
.windowHost >>> .el-dialog.is-fullscreen {
  width: 100% !important;
  height: 100% !important;
  left: 0 !important;
  top: 0 !important;
}
.windowHost >>> .el-dialog__body:first-child {
  padding: 0 20px;
}
.windowHost >>> .el-dialog__body > div:first-child{
  margin-left: 0 !important;
  padding: 0;
  overflow: auto;
}
.windowHost >>> .el-dialog__body > section:first-child{
  margin-left: 0 !important;
  padding: 0;
}
.windowHost >>> footer {
  overflow: auto;
}
.windowHost >>> .el-dialog__header:has(.win-header) {
  position: sticky;
  top: 0;
  padding: 0;
  z-index: 5;
}
// .windowHost >>> .el-dialog:active{
//    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
// }
.win-header {
  display: flex;
  justify-content: space-between;
  padding: 0 .1rem;
  background-color: oklch(93% 0 0 / 1);
}
.win-header .el-button--mini.is-circle {
  padding: 0.5px;
}
.win-icon {
  display: flex;
  align-items: center;
}
.win-icon i {
  color: #000;
}
.win-title {
  line-height: .55rem;
}
.dialog-resize {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize; /* 调整大小箭头 */
}
.v-modal {
  position: sticky;
}
</style>



// WEBPACK FOOTER //
// src/common/WindowHost.vue